import { t } from "@lingui/macro"
import { observer } from "mobx-react"
import { useMemo } from "react"

import { IStatusChipProps, StatusChip } from "src/components/StatusChip"

interface IProps {
    status: BookingStatus
}

export const BookingStatusChip = observer(({ status }: IProps) => {
    const chipProps = useMemo((): IStatusChipProps => {
        if (status === "Approved") {
            return {
                state: "positive",
                label: t`bookings-view.status-chip-approved-status`,
            }
        } else if (status === "Cancelled") {
            return {
                state: "negative",
                label: t`bookings-view.status-chip-cancelled-status`,
            }
        } else {
            return {
                state: "neutral",
                label: t`bookings-view.status-chip-unknown-status`,
            }
        }
    }, [status])

    return <StatusChip {...chipProps} />
})
